// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"0eaefcdc","453":"03346f77"}[chunkId] + ".chunk.js";
};